export const environment = {
  production: true,
  appVersion: '4.3.0',
  analyticsurl: "http://telioev-prod-lb-1199560407.ap-south-1.elb.amazonaws.com:8099",
  grafanaBaseUrl: "https://grafana.telioev.com/d/",
  DOMAIN_NAME: 'cms.telioev.com',
  API_BASE_PATH: "api",
  branding: {
    title: 'TelioEV',
    footer: {
      website: 'www.telioev.com',
      supportEmail: 'support@telioev.com',
      location: 'Hyderabad,Telangana-500050'
    },
    mapInfo: {
      lat: 22.87021236203436,
      lng: 78.45861722464625
    }
  }
};



